import classNames from 'classnames'

const IncidentTabs = ({filters, setFilters, isDarkMode, text, setIsTabClicked, statusOptions}) => {
    const handleTabChange = (value) => {
        setIsTabClicked(prev => !prev)
        if (value === text.resource_options.all.value) {
            setFilters({...filters, statuses: statusOptions})
            return
        }
        setFilters({
            ...filters,
            statuses: statusOptions.filter(status => status.value === value)
        })
    }

    const isActive = (value) => {
        if (value === text.resource_options.all.value && filters.statuses.length > 1) return true
        return filters.statuses.length === 1 && filters.statuses[0].value === value
    }

    return (
        <div className={classNames('sections', {dark: isDarkMode})}>
            {[text.resource_options.all, ...statusOptions].map((item, index) => (
                <span key={index}
                    onClick={() => handleTabChange(item.value)}
                    className={classNames('section-text', {
                        dark: isDarkMode,
                        active: isActive(item.value)
                    })}
                >
                    {item.label}
                </span>
            ))}
        </div>
    )
}

export default IncidentTabs
